import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}email-templates/`;

class EmailTemplateService {
  getAll(params = {}, companyId = null) {
    return axios.get(API_URL, {
      params,
      headers: buildHeaders({}, companyId),
    });
  }

  create(payload, companyId = null) {
    return axios.post(API_URL, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  update(id, payload, companyId = null) {
    return axios.put(`${API_URL}${id}`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  delete(id, companyId = null) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders({}, companyId),
    });
  }
}

export default new EmailTemplateService();
